if (!Array.prototype.includes) {
    Array.prototype.includes = function (itemToTest) {
        return !!this.find(function (item) { return item === itemToTest; });
    };
}
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}



//////////////////
// WEBPACK FOOTER
// ./src/polyfills.ts
// module id = 138
// module chunks = 1